<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="form.Name"
                  label="縣市名稱"
                  :rules="formRules.name"
                  list="datalist-county-in__county-addedit-dialog"
                >
                  <template v-slot:append>
                    <datalist id="datalist-county-in__county-addedit-dialog">
                      <option
                        v-for="county in activeCountyList"
                        :key="`county-datalist-${county.ID}`"
                      >{{county.Name}}</option>
                    </datalist>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="save"
        >儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    editingId: {
      type: Number,
      required: true,
      default: -1
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      Name: ""
    }
  }),
  computed: {
    formRules() {
      return {
        name: [v => !!v || "請輸入名稱"]
      };
    },
    formTitle() {
      return this.editingId === -1 ? "新增" : "編輯";
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    editingIdx() {
      return this.$store.state.county.list.findIndex(
        o => o.ID == this.editingId
      );
    },
    ...mapGetters(["activeCountyList", "countries"])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;

      if (
        this.editingId < 0 &&
        this.activeCountyList.findIndex(o => o.Name == this.form.Name) >= 0 &&
        !window.confirm(
          `已經有一位同樣名稱的縣市「${this.form.Name}」\n確定仍要新增?`
        )
      ) {
        return;
      }

      this.isLoading = true;
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          this.isLoading = false;
          return alert("發生異常：無法找到編輯物件");
        }
        this.$services.county
          .edit(this, this.form)
          .then(res => {
            this.$set(
              this.$store.state.county.list,
              this.editingIdx,
              res.data.result
            );
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      } else {
        this.$services.county
          .add(this, this.form)
          .then(res => {
            this.$store.state.county.list.splice(0, 0, res.data.result);
            this.$emit("updated", res.data.result);
            this.close();
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    resetForm() {
      if (this.editingId > -1) {
        if (this.editingIdx < 0) {
          alert("發生異常：無法找到編輯物件");
          return this.close();
        }
        this.form = JSON.parse(
          JSON.stringify(this.$store.state.county.list[this.editingIdx])
        );
      } else {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
      }
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
    this.isLoading = true;
    this.$services.county.prepareData(this).finally(() => {
      this.isLoading = false;
    });
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>